var React = require('react');

function D1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"D1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},React.createElement("path",{"d":"M9.45,0A40,40,0,1,1,0,79.47Z","fill":"#73c9bd","style":{"mixBlendMode":"multiply"}}))]);
}

D1.defaultProps = {"viewBox":"0 0 44.75 79.76"};

module.exports = D1;

D1.default = D1;
